module.exports = __webpack_public_path__ + "media/images/rank/gold-13f20e49e70ac68d82a4575d1670de0c.png";